export default "__VITE_ASSET__Cj$HCBSW__"